import React, { useContext, useEffect } from "react";
import "./About.css";
import "./ResponsiveAbout.css";
import Zoom from "react-reveal/Zoom";
import Aos from "aos";
import { dataContext } from "../../context/DataContextProvider";

const About = () => {
  useEffect(() => {
    Aos.init();
  }, []);
  const { allWebParts } = useContext(dataContext);

  const filterAllWebParts = allWebParts?.filter(
    (x) => x.uniqueName === "about"
  );

  const filetrKeyAbout = (key) => {
    if (filterAllWebParts) {
      const result = JSON.parse(filterAllWebParts[0]?.specification)?.filter(
        (item) => {
          return item.Key === key;
        }
      );
      return result;
    }
  };

  return (
    <div className="about" id="about">
      <div className="content">
        <div className="left-section">
          <h2>{filetrKeyAbout("about-title")?.map(
                    (item) => item.Value
                  )}</h2>
          <div className="note-Container">
            <div className="p-container">
                <p>
                {filetrKeyAbout("about-paragraph")?.map(
                    (item) => item.Value
                  )}
                </p>
            </div>
          </div>
        </div>
        <div className="right-section">
          <img src={filetrKeyAbout("about-image")?.map(
                    (item) => item.Value
                  )} alt="woman-hand" />
        </div>
      </div>
      <img
        src="/pic/Secondshape.png"
        alt="second-shape"
        className="second-shape"
      />
    </div>
  );
};

export default About;
